import { Card, CardContent } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

interface ChildrenStatsChartsProps {
  byClass: Record<string, number>;
  linkedParents: number;
  total: number;
}

const COLORS = [
  "hsl(var(--primary))",
  "hsl(var(--accent))",
  "#f59e0b",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#6366f1",
];

const ChildrenStatsCharts = ({ byClass, linkedParents, total }: ChildrenStatsChartsProps) => {
  const pieData = Object.entries(byClass).map(([name, value]) => ({ name, value }));
  const linkedPercent = total > 0 ? Math.round((linkedParents / total) * 100) : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card className="shadow-card">
        <CardContent className="p-4">
          <h4 className="text-sm font-medium text-foreground mb-3">توزيع الأطفال على الفصول</h4>
          {pieData.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-6">لا توجد بيانات</p>
          ) : (
            <div className="h-48">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={pieData}
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={70}
                    dataKey="value"
                    label={({ name, value }) => `${name}: ${value}`}
                    labelLine={false}
                  >
                    {pieData.map((_, idx) => (
                      <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="shadow-card">
        <CardContent className="p-4 flex flex-col items-center justify-center h-full">
          <h4 className="text-sm font-medium text-foreground mb-4">ربط أولياء الأمور</h4>
          <div className="relative w-28 h-28">
            <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90">
              <circle
                cx="18" cy="18" r="15.5"
                fill="none"
                stroke="hsl(var(--muted))"
                strokeWidth="3"
              />
              <circle
                cx="18" cy="18" r="15.5"
                fill="none"
                stroke="hsl(var(--primary))"
                strokeWidth="3"
                strokeDasharray={`${linkedPercent} ${100 - linkedPercent}`}
                strokeLinecap="round"
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-xl font-bold text-foreground">{linkedPercent}%</span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-2">{linkedParents} من {total} مربوط</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ChildrenStatsCharts;
